"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Time =
/*#__PURE__*/
function () {
  function Time() {
    var sec = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var nsec = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    _classCallCheck(this, Time);

    if (!Number.isInteger(sec)) {
      if (nsec != 0) {
        throw Error('If secs is a float, nsecs cannot be set');
      }

      var floatSecs = sec;
      sec = Math.floor(floatSecs);
      nsec = Math.floor((floatSecs - sec) * 1e9);
    }

    var secsOver = Math.floor(nsec / 1000000000);
    this.sec = sec + secsOver;
    this.nsec = nsec - secsOver * 1000000000;
  }

  _createClass(Time, [{
    key: "isZero",
    value: function isZero() {
      return this.sec === 0 && this.nsec === 0;
    }
  }, {
    key: "toSec",
    value: function toSec() {
      return this.sec + this.nsec / 1e9;
    }
  }, {
    key: "toNsec",
    value: function toNsec() {
      return this.sec * 1e9 + this.nsec;
    }
  }, {
    key: "toTime",
    value: function toTime() {
      return this.toSec();
    }
  }], [{
    key: "fromSecs",
    value: function fromSecs(floatSecs) {
      var sec = Math.floor(floatSecs);
      var nsec = Math.floor((floatSecs - sec) * 1000000000);
      return new this(sec, nsec);
    }
  }]);

  return Time;
}();

var _default = Time;
exports["default"] = _default;